/*
 * Mobile tap support for Only Authentics price reveal.
 * Uses delegated events so prices added by collection filters/quick shop also work.
 */
(function () {
  var priceSelector = '.oa-price-reveal, [data-pf-type="ProductPrice2"]';
  var revealedClass = 'oa-price-is-revealed';
  var touchPointer = window.matchMedia('(hover: none), (pointer: coarse)');

  function concealOthers(exception) {
    document.querySelectorAll('.' + revealedClass).forEach(function (price) {
      if (price !== exception) price.classList.remove(revealedClass);
    });
  }

  document.addEventListener('click', function (event) {
    if (!touchPointer.matches) return;

    var price = event.target.closest(priceSelector);

    if (!price) {
      concealOthers(null);
      return;
    }

    if (!price.classList.contains(revealedClass)) {
      event.preventDefault();
      event.stopPropagation();
      concealOthers(price);
      price.classList.add(revealedClass);
    }
  }, true);
}());
